module.exports = __webpack_public_path__ + "static/media/projectsIcon.c938f2e4.svg";